import React, { useState } from 'react';
import { Container, Row, Col, Card, CardBody } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import ContactInfo from '../components/qa/ContactInfo';
import NavCategory from '../components/qa/NavCategory';
import QaList from '../components/qa/QaList';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import getRole from '../utils/getRole';
import { qaCategories } from '../data/qa/qaCategories';
import { qaItems } from '../data/qa/qaItems';
import type { Role } from '../types/common';
import type { QaCategory, QaItem } from '../types/qa';

const QA = (): React.ReactElement => {
  const { t } = useTranslation();
  const { roles } = useSelector((state: RootState) => state.session);
  const myRole: Role = getRole(roles);
  const displayedCategories: QaCategory[] = qaCategories.filter((category) => category.contentsFor.includes(myRole));
  const initialCategory: string = displayedCategories.length ? displayedCategories[0].id : '';
  const [selectedCategory, setSelectedTab] = useState<string>(initialCategory);
  const filteredItems: QaItem[] = qaItems.filter((item) => item.category === selectedCategory);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log(selectedCategory);
  // }, [selectedCategory]);

  // EVENT HANDLER
  // ================================================================================

  // タブをクリックして通常ビューと詳細ビューを切り替えたとき
  const handleTabClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    // console.log(event.currentTarget.id);
    const id: string = event.currentTarget.id;
    setSelectedTab(id);
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('helpCenter.qa.title')} subtitle={t('helpCenter.title')} className="text-sm-left" />
        <Col className="d-flex justify-content-end align-items-end">
          <ContactInfo />
        </Col>
      </Row>

      <Card small className="mb-4">
        <CardBody>
          <NavCategory selectedCategory={selectedCategory} categories={displayedCategories} onSelect={handleTabClick} />
        </CardBody>
      </Card>
      <Card small className="">
        <CardBody>
          <QaList items={filteredItems} />
        </CardBody>
      </Card>
    </Container>
  );
};

export default QA;
